/**
 * Mode-aware UI configuration derived from a property's `subjectType`.
 *
 * The implementation moved to `packages/core/src/utils/subject-mode.ts` so the
 * workflow catalog (which lives in `@repo/core`) can gate playbooks on the same
 * capability flags the UI gates sections on. This file stays as a re-export so
 * the ~dozen existing call sites keep their import path.
 */
export {
	subjectModeConfig,
	type SubjectModeConfig,
	type PropertyProjectType,
} from "@repo/core/client";
